import React, { Component }from 'react';
import HttpUtil from '../commonjs/httpUtil';
import $ from 'jquery';
import Method from '../commonjs/comModule';
import KeyCode from '../commonjs/keyCodes';
import keyListener from '../commonjs/keyListener';
import RequestUrl from '../commonjs/urlConfiger';
// 配置文件数据
let partnerCode = "SAXYD_ZX";//SAXYD_ZX
let unmFoucs = 0,unmFousOut=true;
if(window._APP){
    partnerCode = window._APP.getPartnerCode();
}
export default class IndexDraw extends Component{
    constructor(props) {
            super(props);
            this.state = {
                text:''
            };
    }
    componentDidMount() {//组件渲染之后调用，只调用一次。
      document.addEventListener("keydown", this.handleKeyDown)
      console.log(this.props.pubData)
    }
    componentWillUnmount(){ // 组件卸载
        document.removeEventListener("keydown",this.handleKeyDown)
        keyListener.set(null);
    }
    componentWillMount() { //组件初始化时只调用，以后组件更新不调用，整个生命周期只调用一次，此时可以修改state。
       keyListener.set(this.handleKeyDown);
       unmFousOut = true;
       unmFoucs = 0;
       RequestUrl.getPBEnter({oid:this.props.pbJson.screeninfo.contentId+"0301",on:this.props.pubData[0].positionName,pat:this.props.pbJson.screeninfo.typeName,pan:this.props.pbJson.screeninfo.contentText,paid:"1001"},"0");
    }
    handleKeyDown = (keyCode) => {
      const wid = this.props.pubData[0].popupItemList.length-1;

      if(keyCode == KeyCode.back ){

        this.props.offPub(keyCode,false)
      }else if(keyCode == KeyCode.left && wid  >=  unmFoucs && unmFoucs > 0 && unmFousOut ){//左

        unmFoucs--
      }else if(keyCode == KeyCode.right && wid > unmFoucs && unmFousOut ){//右

        unmFoucs++
      }else if(keyCode == KeyCode.center && unmFousOut ){//确定
        let pb = JSON.parse($(".out-box").eq(unmFoucs).attr("data-pb"));
        RequestUrl.getPBEnter(
          {
            oid:this.props.pbJson.screeninfo.contentId+"03010"+$(".out-box").eq(unmFoucs).attr("data-num"),
            on:pb.contentName,
            pat:this.props.pbJson.screeninfo.typeName,
            pan:this.props.pbJson.screeninfo.contentText,
            paid:this.props.pbJson.screeninfo.contentId,
            cont:pb.contentName,
            contid:pb.cpContentId
          },"0");
        this.props.toAndroid($(".out-box").eq(unmFoucs).attr("data-info"),keyCode)
      }else if( keyCode == KeyCode.down ){ //下

         unmFousOut = false;
        $(".out-box").removeClass("out-box-active");
        $(".out-btn-style").addClass("out-btn-style-active");
      }else if( keyCode == KeyCode.up ){//上

         unmFousOut = true;
        $(".out-box").eq(unmFoucs).addClass("out-box-active");
        $(".out-btn-style").removeClass("out-btn-style-active");
      }else if(keyCode == KeyCode.center && !unmFousOut ){//

        RequestUrl.getPBEnter({oid:this.props.pbJson.screeninfo.contentId+"030100",on:"回到专题",pat:this.props.pbJson.screeninfo.typeName,pan:this.props.pbJson.screeninfo.contentText,paid:this.props.pbJson.screeninfo.contentId},"0");
        this.props.offPub(keyCode,true);
      }

      if(unmFousOut){
        $(".out-box").removeClass("out-box-active");
        $(".out-box").eq(unmFoucs).addClass("out-box-active");
      }



    }


render(){
  const {pubData} = this.props;
  console.log(pubData)
        return(
            <div className="com-pub">
              {
                pubData.map((key,i)=>{
                  let style = {
                    width:key.bgWeight / 100 + "rem",
                    height:key.bgHeight / 100 + "rem",
                    top:"50%",
                    left:"50%",
                    marginTop:-(key.bgHeight / 2 ) / 100 +"rem",
                    marginLeft:-(key.bgWeight / 2 ) / 100 +"rem",
                    background:"url("+key.positionBgPic+") no-repeat",
                    backgroundSize:"100% 100%",
                  }
                  let elementStyle = {
                    width:key.elementHeight / 100 + "rem",
                    height:key.elementWeight / 100 + "rem",
                    top:key.posY / 100 + "rem",
                    left:key.posX / 100 + "rem",
                    background:"url("+key.elementPic+") no-repeat",
                    backgroundSize:"100% 100%",
                  };
                  let wid = key.popupStyleCols>1 ? ((key.popupStyleCols * key.popupItemList[0].weight)+(key.popupStyleCols-1)*39)  / 100 : key.popupStyleCols * key.popupItemList[0].weight / 100;
                  let tenClass = {
                    width:wid + "rem",
                    margin:"0 auto"
                    //top:((key.bgHeight / 100 ) / 2) - ((key.popupItemList[0].height / 100) / 2 )+ "rem"
                  }
                  return(
                      <div className="sin-out" style={style} key={i}>
                          <div className="sin-content">
                            <p className="sin-out-tips">{key.popupText}</p>
                            <div style={tenClass}>
                                <div className="out-center" style={{top:((key.bgHeight / 100 ) / 2) - ((key.popupItemList[0].height / 100) / 2 )+ "rem"}}>
                                  {
                                    key.popupItemList.map((val,j)=>{
                                      let styleName = {
                                        width:val.weight / 100 + "rem",
                                        height:val.height / 100 + "rem",
                                        background:"url("+val.itemPic+") no-repeat",
                                        backgroundSize:"100% 100%",
                                        marginRight:!Method.isInteger(j+1,key.popupStyleCols)?".39rem":"",
                                      }
                                      let classFoucs = j == 0 ? "out-box out-box-active" : "out-box";
                                      return (
                                        <div key={j} data-num = {j+1} data-pb={JSON.stringify(val)} data-info={JSON.stringify(val.appInfo)} style={styleName} className={classFoucs}></div>
                                      )
                                    })
                                  }
                                  </div>
                              </div>
                              <div className="out-btn-style" style={{left:((key.bgWeight / 100) / 2) - 1.4 +"rem"}}>再看一会儿</div>
                          </div>
                          {key.isAddElementPic == "1" ? <div className="out-elementPic" style={elementStyle}></div> : "" }
                      </div>
                  )
                })
              }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/signOut.js